/**
 * Api Documentation
 * Api Documentation
 *
 * OpenAPI spec version: 1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { CreateSearchPayload } from '../model/createSearchPayload';
import { SearchData } from '../model/searchData';
import { UpdateSearchPayload } from '../model/updateSearchPayload';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable()
export class SearchService {

    protected basePath = 'https://localhost';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * Create search
     * 
     * @param payload Search to be created
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public createSearch(payload?: CreateSearchPayload, observe?: 'body', reportProgress?: boolean): Observable<SearchData>;
    public createSearch(payload?: CreateSearchPayload, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<SearchData>>;
    public createSearch(payload?: CreateSearchPayload, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<SearchData>>;
    public createSearch(payload?: CreateSearchPayload, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<SearchData>(`${this.basePath}/api/searches`,
            payload,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Delete search
     * 
     * @param searchId Search
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public deleteSearch(searchId: number, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public deleteSearch(searchId: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public deleteSearch(searchId: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public deleteSearch(searchId: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (searchId === null || searchId === undefined) {
            throw new Error('Required parameter searchId was null or undefined when calling deleteSearch.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.delete<any>(`${this.basePath}/api/searches/${encodeURIComponent(String(searchId))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Get search
     * 
     * @param searchId Search
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getSearch(searchId: number, observe?: 'body', reportProgress?: boolean): Observable<SearchData>;
    public getSearch(searchId: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<SearchData>>;
    public getSearch(searchId: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<SearchData>>;
    public getSearch(searchId: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (searchId === null || searchId === undefined) {
            throw new Error('Required parameter searchId was null or undefined when calling getSearch.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<SearchData>(`${this.basePath}/api/searches/${encodeURIComponent(String(searchId))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Get list of searches for an authenticated enduser
     * 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getSearchList(observe?: 'body', reportProgress?: boolean): Observable<Array<SearchData>>;
    public getSearchList(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<SearchData>>>;
    public getSearchList(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<SearchData>>>;
    public getSearchList(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<Array<SearchData>>(`${this.basePath}/api/searches`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Partial update search
     * 
     * @param searchId Search
     * @param payload Search to update (null values ignored)
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public partialUpdateSearch(searchId: number, payload?: UpdateSearchPayload, observe?: 'body', reportProgress?: boolean): Observable<SearchData>;
    public partialUpdateSearch(searchId: number, payload?: UpdateSearchPayload, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<SearchData>>;
    public partialUpdateSearch(searchId: number, payload?: UpdateSearchPayload, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<SearchData>>;
    public partialUpdateSearch(searchId: number, payload?: UpdateSearchPayload, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (searchId === null || searchId === undefined) {
            throw new Error('Required parameter searchId was null or undefined when calling partialUpdateSearch.');
        }


        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.patch<SearchData>(`${this.basePath}/api/searches/${encodeURIComponent(String(searchId))}`,
            payload,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
